var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEmptyReserved = function SvgEmptyReserved(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 81,
    height: 60,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#CDD3D8",
    d: "M32.385 14c.34 0 .62.28.62.62V19h15v-4.38c0-.34.28-.62.62-.62s.62.28.62.62V19h3.75c2.76 0 5 2.24 5 5v25c0 2.76-2.24 5-5 5h-24.99c-2.76 0-5-2.24-5-5V24c0-2.76 2.24-5 5-5h3.75v-4.38c0-.34.28-.62.62-.62zm-.63 9.38v-3.12h-3.75c-2.07 0-3.75 1.68-3.75 3.75v3.75h32.5v-3.75c0-2.07-1.68-3.75-3.75-3.75h-3.75v3.12c0 .34-.28.62-.62.62s-.62-.28-.62-.62v-3.12h-15v3.12c0 .34-.28.62-.62.62s-.62-.28-.62-.62zm25 5.62h-32.5v20c0 2.07 1.68 3.75 3.75 3.75h25c2.07 0 3.75-1.68 3.75-3.75z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#F7F8FA",
    d: "M31.75 23.38v-3.12H28c-2.07 0-3.75 1.68-3.75 3.75v3.75h32.5v-3.75c0-2.07-1.68-3.75-3.75-3.75h-3.75v3.12c0 .34-.28.62-.62.62s-.62-.28-.62-.62v-3.12h-15v3.12c0 .34-.28.62-.62.62s-.62-.28-.62-.62z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#CDD3D8",
    strokeMiterlimit: 10,
    strokeWidth: 1.2,
    d: "M8.53 34a2.9 2.9 0 1 0 0-5.8 2.9 2.9 0 0 0 0 5.8ZM68.685 17.964l-.288 4.718c-.03.41.406.697.767.512l4.235-2.116c.37-.179.4-.692.06-.923l-3.943-2.611a.535.535 0 0 0-.826.411z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#CDD3D8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "m22.505 6.795-4.85 3.19M21.665 10.815l-3.18-4.85"
  })));
};
export default SvgEmptyReserved;